import * as React from "react";
import { singleton } from "logic/singleton";
const ActiveSliceColContext = React.createContext(void 0);
export default singleton("contexts.ActiveSliceColContext", () => ActiveSliceColContext);
